import { BusinessError, EntityKind, ErrorKind } from '../errors';
import { AlertTypes, ContributionsResponseSchema, ContributionsStatus, isResultSuccess, } from '../types';
/**
 * Contributions service
 */
class ContributionsService {
    contributionsAdapter;
    alertsDispatcher;
    i18nService;
    constructor({ contributionsAdapter, alertsDispatcher, i18nService }) {
        this.contributionsAdapter = contributionsAdapter;
        this.alertsDispatcher = alertsDispatcher;
        this.i18nService = i18nService;
    }
    /**
     * Retrieve Contribution with 'WAITING_FOR_CERTIFICATE' From given demande
     */
    async getWaitingForCertificateContributionFromDemande(demandeId) {
        try {
            const contributions = await this.contributionsAdapter.getContributionFromDemande(demandeId, ContributionsStatus.waitingForCertificate);
            const response = ContributionsResponseSchema.parse(isResultSuccess(contributions) ? contributions.response : undefined);
            return { response };
        }
        catch {
            return {
                error: new BusinessError(ErrorKind.TECHNICAL_ERROR, {
                    entity: EntityKind.CONTRIBUTIONS,
                }),
            };
        }
    }
    /**
     * Update contribution statut with 'ANSWERED' value
     * and add dateReponse
     */
    answerContribution(reference) {
        const patch = [
            {
                op: 'replace',
                path: '/statut',
                value: ContributionsStatus.answered,
            },
            {
                op: 'add',
                path: '/dateReponse',
                value: new Date().toISOString(),
            },
        ];
        return this.contributionsAdapter.patchContributionByReference(reference, patch);
    }
    /**
     * Remove avis of the contribution
     * set statut to ASKED
     * and set /history/begin/metadata/step to preambule
     */
    async removeAnswer(contribution) {
        const patch = [];
        // Delete data for answer
        if (contribution.avis) {
            const answerRemove = {
                op: 'remove',
                path: '/avis',
            };
            patch.push(answerRemove);
        }
        // Update answer status
        const answerStatut = {
            op: 'add',
            path: '/statut',
            value: ContributionsStatus.asked,
        };
        patch.push(answerStatut);
        // Update first step for answer
        const answerFirstStep = {
            op: 'add',
            path: '/history/begin/metadata/step',
            value: 'preambule',
        };
        patch.push(answerFirstStep);
        const result = await this.contributionsAdapter.patchContributionByReference(contribution.reference, patch);
        if (isResultSuccess(result)) {
            const successMessage = this.i18nService.translate('sollicitations.avis.delete.success');
            this.alertsDispatcher.showAlert(AlertTypes.SUCCESS, { message: successMessage });
        }
        else {
            const errorMessage = this.i18nService.translate('sollicitations.avis.delete.error');
            this.alertsDispatcher.showAlert(AlertTypes.ERROR, { message: errorMessage });
        }
        return result;
    }
    /**
     * Create contribution avis financement
     */
    async createContributionAvisFinancement(demandeRef, tiersHref) {
        const tiersReference = tiersHref.split('/').at(-1) ?? '';
        return this.contributionsAdapter.createContributionAvisFinancement(demandeRef, tiersReference);
    }
}
export { ContributionsService };
//# sourceMappingURL=contributions-service.js.map